import { hot } from 'react-hot-loader';
import { useSelector } from 'react-redux';
import * as S from '../store/selectors';
import { useModal } from 'react-simple-modal-provider';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import Card from '../components/Card';
import LinkExternal from '../components/Link/LinkExternal';

//import bgNftImg from '../assets/images/bg/bg-nft.png'; // 192x192
import bgNftX2Img from '../assets/images/bg/bg-nft@2x.png'; // 384x384
//import nft1Img from '../assets/images/nft/nft-1.png';
import nft1X2Img from '../assets/images/nft/nft-1@2x.png';
//import nft2Img from '../assets/images/nft/nft-2.png';
import nft2X2Img from '../assets/images/nft/nft-2@2x.png';
//import nft3Img from '../assets/images/nft/nft-3.png';
import nft3X2Img from '../assets/images/nft/nft-3@2x.png';
//import nft4Img from '../assets/images/nft/nft-4.png';
import nft4X2Img from '../assets/images/nft/nft-4@2x.png';
//import nft5Img from '../assets/images/nft/nft-5.png';
import nft5X2Img from '../assets/images/nft/nft-5@2x.png';
//import nft6Img from '../assets/images/nft/nft-6.png';
import nft6X2Img from '../assets/images/nft/nft-6@2x.png';

import { openSeaUrl, } from '../configs';
import './ScreenOwn.scss';



function ScreenOwn() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  const { open: openMintModal } = useModal('MintModal');
  const isPresaleOpen = useSelector(S.nft.getPresaleOpen);
  const isSaleOpen = useSelector(S.nft.getSaleOpen);
  const isSoldOut = useSelector(S.nft.getSoldOut);

  return (
    <section className="section-own" id="collection">
      <br />
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-8">
            <div className="own__img">
              <img
                width="872" height="500" className="img-responsive" alt="" title=""
                //src={bgNftImg} srcSet={`${bgNftX2Img} 2x`}
                src={bgNftX2Img}
              />
              {isSoldOut && isMobile && <div className="cards__pos-button">
                <LinkExternal href={openSeaUrl}>
                  <button className="btn-round">
                    <span>Buy on OpenSea</span>
                  </button>
                </LinkExternal>
              </div>}
              {(isPresaleOpen || isSaleOpen) && !isSoldOut && isMobile && <div className="cards__pos-button"
                onClick={openMintModal}
              >
                <button className="btn-round">
                  <span>Mint now</span>
                </button>
              </div>}
            </div>
          </div>
          <div className="col-lg-4 col-xl-3 offset-xl-1">
            <div className="pre-title"><span>NFT collection</span></div>
            <h2 className="title">Make <span>Roborovski</span> Your Own</h2>
            <p className="desc">Each Roborovski NFT is a piece of art that tells an immersive and meaningful story of its own.</p>
          </div>
        </div>

        <div className="cards">
          <div className="cards__pos cards__pos--1" data-aos="flip-up">
            <Card
              //poster={nft1Img} posterhd={`${nft1X2Img} 2x`}
              poster={nft1X2Img}
            //name="Roborovski #1224"
            /*summ="2.28"
            icon1="1"
            icon2="4"*/
            />
          </div>
          <div className="cards__pos cards__pos--2" data-aos="flip-down">
            <Card
              //poster={nft2Img} posterhd={`${nft2X2Img} 2x`}
              poster={nft2X2Img}
            //name="Roborovski #65"
            /*summ="1.65"
            icon1="2"
            icon2="5"*/
            />
          </div>
          <div className="cards__pos cards__pos--3" data-aos="flip-up">
            <Card
              //poster={nft3Img} posterhd={`${nft3X2Img} 2x`}
              poster={nft3X2Img}
            //name="Roborovski #724"
            /*summ="1.97"
            icon1="3"
            icon2="6"*/
            />
          </div>
          <div className="cards__pos cards__pos--4" data-aos="flip-down">
            <Card
              //poster={nft4Img} posterhd={`${nft4X2Img} 2x`}
              poster={nft4X2Img}
            //name="Roborovski #9542"
            /*summ="2.01"
            icon1="1"
            icon2="4"*/
            />
            {isSoldOut && !isMobile && <div className="cards__pos-button">
              <LinkExternal href={openSeaUrl}>
                <button className="btn-round">
                  <span>Buy on OpenSea</span>
                </button>
              </LinkExternal>
            </div>}
            {(isPresaleOpen || isSaleOpen) && !isSoldOut && !isMobile && <div className="cards__pos-button">
              <button className="btn-round"
                onClick={openMintModal}
              >
                <span>Mint now</span>
              </button>
            </div>}
          </div>
          <div className="cards__pos cards__pos--5" data-aos="flip-up">
            <Card
              //poster={nft5Img} posterhd={`${nft5X2Img} 2x`}
              poster={nft5X2Img}
            //name="Roborovski #8372"
            /*summ="1.44"
            icon1="2"
            icon2="5"*/
            />
          </div>
          <div className="cards__pos cards__pos--6" data-aos="flip-down">
            <Card
              //poster={nft6Img} posterhd={`${nft6X2Img} 2x`}
              poster={nft6X2Img}
            //name="Roborovski #1132"
            /*summ="1.83"
            icon1="3"
            icon2="6"*/
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default hot(module)(ScreenOwn);
